import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BorderTopTitle } from "../../../../Constants/Constants";
import { BorderTopSubTitle } from "../../../../Data/BonusUi/CreativeCard";

const BorderTop = () => {
  return (
    <Col md="6" xs="12">
      <Card>
        <CommonCardHeader title={BorderTopTitle} span={BorderTopSubTitle} headClass="border-t-danger" />
        <CardBody>
          <P className="mb-0">
            {"Tabs have long been used to show alternative views of the same group of information tabs in software. Known as"}
            <em className="txt-danger">{" “module tabs” "}</em>
            {", these are still used today in web sites. For instance, airline companies such as Ryanair, easyJet and AirMalta use module tabs to enable the user to switch between bookings for flights, hotels and car hire."}
          </P>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderTop;
